import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { getSearchDateRange } from '../helpers/common';
import {
    APPLY_FILTERS, CREW_SELECTION, MOVE_COLUMN, MOVE_CARD,
    GET_CREW_EQUIPMENT_GROUP_LIST_REQUEST, GET_CREW_EQUIPMENT_GROUP_LIST,
    KANBAN_GET_CREW_LIST_REQUEST, KANBAN_GET_CREW_LIST,
    KANBAN_GET_CREW_INFO_REQUEST, KANBAN_GET_CREW_INFO, UPDATE_CREW_INFO,
    GET_WORK_PLAN_REQUEST, GET_WORK_PLAN, CLEAR_CREW_KANBAN,
    CREW_SAVE_REQUEST, CREATE_CREW, RESET_CREW, CREW_SAVE_SUCCESS, CREW_SAVE_FAILURE,
    CREW_GET_GEO_REGION, CREW_GET_GEO_REGION_REQUEST, ASSIGNED_EG, KANBAN_GET_CREW_INFO_ASSIGN, REMOVE_ASSIGN_CREW, CREW_ASSIGN_SAVE, SET_CREW_SEARCH_TEXT, SET_CREW_FILTERED_LIST
} from "../constants/action-types";
import { CREW_EDITED, CREW_ENDED } from '../constants/messages';

export const applyFilters = payload => ({ type: APPLY_FILTERS, payload });

export const moveColumn = payload => ({ type: MOVE_COLUMN, payload });

export const crewSelection = payload => ({ type: CREW_SELECTION, payload });

export const crewListRequest = () => ({ type: KANBAN_GET_CREW_LIST_REQUEST });

export const crewList = (data, range) => ({ type: KANBAN_GET_CREW_LIST, payload: data, range });

export const crewInfoRequest = (crewId, payload) => ({ type: KANBAN_GET_CREW_INFO_REQUEST, crewId, payload });

export const crewInfo = (crewId, payload) => ({ type: KANBAN_GET_CREW_INFO, crewId, payload });

export const crewInfoAssign = (crewId, payload, assignedObj) => ({ type: KANBAN_GET_CREW_INFO_ASSIGN, crewId, payload, assignedObj });

export const workPlanRequest = crewId => ({ type: GET_WORK_PLAN_REQUEST, crewId });

export const workPlan = (crewId, payload) => ({ type: GET_WORK_PLAN, crewId, payload });

export const egListWithCrewRequest = () => ({ type: GET_CREW_EQUIPMENT_GROUP_LIST_REQUEST });

export const egListWithCrew = payload => ({ type: GET_CREW_EQUIPMENT_GROUP_LIST, payload });

export const updateCrew = (crewId, data) => ({ type: UPDATE_CREW_INFO, crewId, payload: data });

export const crewSaveRequest = () => ({ type: CREW_SAVE_REQUEST });

export const clearCrewKanban = () => ({ type: CLEAR_CREW_KANBAN });

export const createCrew = (crewId, data) => ({ type: CREATE_CREW, crewId, payload: data });

export const crewSaveSuccess = () => ({ type: CREW_SAVE_SUCCESS });

export const crewAssignSave = (isAssign) => ({ type: CREW_ASSIGN_SAVE, isAssign });

export const removeAssignCrew = (modifiedCrewList) => ({ type: REMOVE_ASSIGN_CREW, payload: modifiedCrewList });

export const crewSaveFailure = () => ({ type: CREW_SAVE_FAILURE });

export const resetCrew = () => ({ type: RESET_CREW });

export const geoRegionListRequest = () => ({ type: CREW_GET_GEO_REGION_REQUEST });

export const geoRegionList = (data) => ({ type: CREW_GET_GEO_REGION, payload: data });

export const setAssignedEg = () => ({ type: ASSIGNED_EG })

export const setCrewSearchText = (searchText) => ({ type: SET_CREW_SEARCH_TEXT, searchText });

export const setCrewFilteredList = (crewFilteredList) => ({ type: SET_CREW_FILTERED_LIST, crewFilteredList });

export const moveCard = payload => (dispatch, getState) => {
    let isTruck = false;
    const kanban = getState().crewKanban;
    const { sourceCrewId, destCrewId, oldCardIndex } = payload;

    if (kanban.crews[sourceCrewId]) {
        const egId = kanban.crews[sourceCrewId].egList[oldCardIndex];
        isTruck = kanban.egListById[egId] && kanban.egListById[egId].vehicle.is_truck && kanban.egListById[egId].vehicle.is_truck ? kanban.egListById[egId].vehicle.is_truck : null;
    }

    // Move EG into another crew
    dispatch({ type: MOVE_CARD, payload });

    if (sourceCrewId === destCrewId || isTruck) return;
    const selected = [sourceCrewId, destCrewId].filter(id => id !== "unassigned");
    if (selected.length === 0) return;
    dispatch(getWorkPlan(selected));
};

export const getEgListWithCrew = ({ farmId, planTypeId }) => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const params = {
        farm_uuid: farmId, plan_type_id: planTypeId,
        include_crew: true, implement_spec: 1,
        from_date: dateInfo.from, to_date: dateInfo.to
    };

    dispatch(egListWithCrewRequest());
    defaultAgent.get('/api/equipment/group/v1/list', params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(egListWithCrew());
        } else if (agentResult.data)
            dispatch(egListWithCrew(agentResult.data));
    }).catch(ex => {
        dispatch(toastError(ex.message));
        dispatch(egListWithCrew());
    });
};

export const getCrewList = params => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to
    };

    dispatch(crewListRequest());
    defaultAgent.get('/api/crew/v1/list', reqParams).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(crewList());
        } else if (agentResult.data) {
            dispatch(crewList(agentResult.data, search.range));
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        dispatch(crewList());
    });
}

export const getCrewInfo = (selected, assignedObj) => (dispatch, getState) => {
    const state = getState();
    const search = state.analyze.searchParams;
    const dateInfo = getSearchDateRange(search);
    const { farmId } = state.crewKanban.filters;
    let isAssigned = assignedObj && assignedObj.hasOwnProperty("isAssign") ? assignedObj.isAssign : false;

    const params = {
        farm_uuid: assignedObj && assignedObj.farmId ? assignedObj.farmId : farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to
    };
    for (const crewId of selected) {
        const findCrews = state.crewKanban.crewList.filter(e => e.crew_uuid === crewId);
        if (findCrews.length === 0) continue;

        dispatch(crewInfoRequest(crewId, findCrews[0]));
        if (isAssigned) dispatch(crewAssignSave(isAssigned));
        defaultAgent.get('/api/crew/v1/info', { ...params, crew_uuid: crewId }).then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(crewInfo(crewId));
            } else if (agentResult.code === 1000)
                if (isAssigned) {
                    dispatch(crewInfoAssign(crewId, agentResult.data, assignedObj));
                    dispatch(crewAssignSave(false))
                } else {
                    dispatch(crewInfo(crewId, agentResult.data));
                }
            else dispatch(crewInfo(crewId));
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(crewInfo(crewId));
        });
    }
}

export const getWorkPlan = selected => (dispatch, getState) => {
    const kanban = getState().crewKanban;
    for (const crewId of selected) {
        if (!(kanban.crews[crewId] && kanban.crews[crewId].info
            && kanban.crews[crewId].info.hasOwnProperty("acres")
            && kanban.crews[crewId].info.isHaveWorkPlan))
            continue;

        const crew = kanban.crews[crewId].info;
        const egList = kanban.crews[crewId].egList.map(egId => {
            const spec = {};
            const item = kanban.egListById.hasOwnProperty(egId) ? kanban.egListById[egId] : null;
            if (item && item.implement.specification && Object.keys(item.implement.specification).length) {
                if (item.implement.specification.hasOwnProperty('rows')) {
                    spec["rows"] = item.implement.specification.rows;
                    spec["row_spacing"] = item.implement.specification.row_spacing;
                } else if (item.implement.specification.hasOwnProperty('width')) {
                    spec["width"] = item.implement.specification.width;
                }
            }

            return {
                equipment_group_uuid: egId,
                specification: Object.keys(spec).length > 0 ? spec : null
            };
        });

        let params = {
            farm_uuid: kanban.filters.farmId,
            plan_type_id: kanban.filters.planTypeId,
            acres: crew.acres,
            utilization: crew.utilization,
            avg_working_speed: crew.avg_working_speed,
            working_hours_per_day: crew.working_hours_per_day,
            non_working_days: crew.non_working_days,
            equipment_group_list: egList
        };

        if (crew.work_plan_method_id === 3) {
            params = {
                ...params,
                acres_per_day: crew.acres_per_day,
                working_days: crew.working_days,
                work_plan_method_id: crew.work_plan_method_id
            }
        }

        dispatch(workPlanRequest(crewId));
        defaultAgent.post('/api/crew/workplan', params).then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(workPlan(crewId));
            } else if (agentResult.data) {
                dispatch(workPlan(crewId, agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(workPlan(crewId));
        });
    }
};

export const saveCrew = () => (dispatch, getState) => {
    const state = getState();
    const { crews, filters: { farmId, planTypeId } } = state.crewKanban;
    const crewList = [];

    for (const crewId in crews) {
        if (!crews[crewId].isChanged) continue;
        const crew = crews[crewId];
        if (!(crew.info && crew.info.hasOwnProperty("crew_name"))) continue;
        crewList.push({ ...crew.info, equipment_group_list: crew.egList.map(e => e.id ? e.id : e), plan_type_id: planTypeId });
    }
    dispatch(crewSaveRequest());
    defaultAgent.put('/api/crew/bulk/save', { farm_uuid: farmId, crews: crewList })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === CREW_EDITED.code) {
                dispatch(crewSaveSuccess());
                dispatch(removeAssignCrew(crewList));
                dispatch(toastSuccess(agentResult.message));
            } else if (agentResult.message) {
                dispatch(crewSaveFailure());
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}

export const updateEndCrew = crewId => (dispatch, getState) => {
    const state = getState();
    const { farmId } = state.crewKanban.filters;

    defaultAgent.put('/api/crew/end', { farm_uuid: farmId, crew_uuid: crewId }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === CREW_ENDED.code) {
            dispatch(crewSaveSuccess());
            dispatch(getCrewInfo([crewId]));
            dispatch(toastSuccess(agentResult.message));
        } else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
}

export const getGeoRegionList = (farmId, includeRemoved = false, range) => dispatch => {
    dispatch(geoRegionListRequest());
    const dateRange = range ? range : {};
    defaultAgent.get('/api/geo/region/list', { farm_uuid: farmId, include_removed: includeRemoved, ...dateRange })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(geoRegionList([], farmId));
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.data)
                dispatch(geoRegionList(agentResult.data, farmId));
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}
